 document.addEventListener('DOMContentLoaded', function() {
    var elements = document.getElementsByClassName('fullpageLoader');
    for (var i = 0; i < elements.length; i++) {
        var element = elements[i];
        var r = parseInt(element.getAttribute('data-r'), 16);
        var g = parseInt(element.getAttribute('data-g'), 16);
        var b = parseInt(element.getAttribute('data-b'), 16);
        var a = parseFloat(element.getAttribute('data-a'));
        element.style.backgroundColor = 'rgba(' + r + ', ' + g + ', ' + b + ', ' + a + ')';
    }
});



document.addEventListener("DOMContentLoaded", function() {
  var observer;

  function startObserver() {
    if (observer) {
      observer.disconnect();
    }

    observer = new IntersectionObserver(function(entries) {
      var i = 0;
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          setTimeout(function() {
            entry.target.classList.add('visible');
          }, 100 * i);
          i++;
        }
      });
    }, { threshold: 0.1 });

    var items = document.querySelectorAll('.fade-in');
    items.forEach(function(item) {
      observer.observe(item);
    });
  }

  // Run observer on page load
  startObserver();

  // Initialize lastURL to current URL
  let lastURL = window.location.href;

  // Create an interval to check for URL changes
  setInterval(function() {
    // If the URL has changed
    if (lastURL !== window.location.href) {
      // Update the lastURL to the current one
      lastURL = window.location.href;
      
      // Re-run observer after a slight delay to allow for products to load
      setTimeout(startObserver, 500); // adjust the timeout as necessary
    }
  }, 100); // Checks every 100 milliseconds, adjust as necessary
});

